import { Link } from "react-router-dom";

export const NavItem = ({ link, onSection, className, testid }) =>
  link.to ? (
    <Link to={link.to} data-testid={testid} className={className}>
      {link.label}
    </Link>
  ) : (
    <a href={`/#${link.id}`} onClick={(e) => onSection(e, link.id)} data-testid={testid} className={className}>
      {link.label}
    </a>
  );
